import { render, staticRenderFns } from "./GP2BrowserMenuBar.vue?vue&type=template&id=a2182396&scoped=true&"
import script from "./GP2BrowserMenuBar.vue?vue&type=script&lang=js&"
export * from "./GP2BrowserMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./GP2BrowserMenuBar.vue?vue&type=style&index=0&id=a2182396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2182396",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2182396')) {
      api.createRecord('a2182396', component.options)
    } else {
      api.reload('a2182396', component.options)
    }
    module.hot.accept("./GP2BrowserMenuBar.vue?vue&type=template&id=a2182396&scoped=true&", function () {
      api.rerender('a2182396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/gp2Browser/GP2BrowserMenuBar.vue"
export default component.exports